export const defaultFacilityProfileWidgets = [
	{
		enabled: true,
		id: "floorPlans",
		index: 0
	},
	{
		enabled: true,
		id: "activities",
		index: 1
	},
	{
		enabled: true,
		id: "files",
		index: 2
	},
	{
		enabled: true,
		id: "device-manager",
		index: 3
	},
	{
		enabled: true,
		id: "facility-condition",
		index: 4
	}
];
